export type AssignmentBillResult = {
    billID: string;
    measureType: string;
    measureNum: number;
    measure: string;
    subject: string;
    primaryAuthor: string;
    assignmentList: AssignmentResult[];
};

export type AssignmentResult = {
    id: number;
    owner: string;
    requestType: string;
    requestStatus: string;
    requestPriority: string;
    assignmentUserName: string;
    assignmentTask: string;
    assignmentDue?: Date;
    currentAssignmentOrder?: number;
    assignmentOrder?: number;
    currentAssignmentId?: number;
    assignmentsCount?: number;
};

export type FlatAssignmentResult = AssignmentResult & {
    billID: string;
    measureType: string;
    measureNum: number;
    measure: string;
    subject: string;
    primaryAuthor: string;
};

export type AssignmentReport = {
    id: number;
    name: string;
    type: string;
    request: Request;
    response: Response;
};

export type AssignmentReportResponse = Response & {
    message: string;
    status: string;
};

export type Request = {
    type: string;
    take: number;
    skip: number;
    page: number;
    filters: Filter[];
    display: Display[];
    sort: Sort[];
};

export type Filter = {
    name: string;
    type: string;
    path: string;
    comparison: string;
    values: any[];
    exclude: boolean;
    active: boolean;
    instances?: string[];
    filters?: Filter[];
};

export type FilterOption = {
    name: string;
    check?: boolean;
};

export type ReportFilter = {
    name: string;
    value: string;
    low: string;
    high: string;
    comparison: string;
    values?: string[];
    path?: string;
    options?: FilterOption[];
};

export type Response = {
    total: number;
    results: Result[];
};

export type Result = {
    results: AssignmentBillResult[];
};

export type LoadDetail = {
    report: AssignmentReport;
    requestStatus: string[];
    assignmentStatus: string[];
    assignmentTask: string[];
    get: () => AssignmentBillResult[];
    set: (results: AssignmentBillResult[]) => void;
    filter: (assignment: AssignmentBillResult) => boolean;
};

export type Sort = {
    name: string;
    direction: string;
};

export type Display = {
    name: string;
    type: string;
    display: string;
    path: string;
};

export enum Column {
    Bill = 'Bill',
    BillTitle = 'Bill Title',
    Priority = 'Priority',
    RequestType = 'Request Type',
    RequestStatus = 'Request Status',
    Task = 'Task',
    TaskDue = 'Task Due',
}

export type TabDetail = {
    type: Type;
    message: string;
    assignments: AssignmentBillResult[];
};

export enum Type {
    Active = 'Active',
    Pending = 'Pending',
    Completed = 'Completed',
    Cancelled = 'Cancelled',
    Coordinators = 'Coordinators',
}

export enum Task {
    Analyze = 'Analyze',
    Approve = 'Approve',
    Coordinate = 'Coordinate',
}
